module.exports = __webpack_public_path__ + "img/LS20130822_greenfire_011.5b7b3ce7.jpg";